import React from 'react'
import { Row, Col, Image } from 'react-bootstrap';
import parse from 'html-react-parser';
import { useStateValue } from '../../utilities/StateProvider';
import { SHOW_RESUMEN } from '../../../images/images';

export default function ShowResume() {

    const [ { cart, isInterior }, _ ] = useStateValue();

    if (!cart.show) {
        return null;
    }

    return (
        <Row className="service-row">
            <Col xs="4">
                <Image src={SHOW_RESUMEN} roundedCircle height={80}/>
                <div className="title">{cart.show && cart.show.name}</div>
            </Col>
            <Col xs="5" className="show-content">
                {cart.show && parse(cart.show.content)};
            </Col>
            <Col xs="3" className="price">
                <span>${(!isInterior) ? cart.show.price : cart.show.price_interior}</span>
            </Col>
        </Row>
    )
}
